/**
 * Schermteksten in het Koreaans.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const ko: Teksten = {
  kamerOphalen: "방 가져오는 중…",
  kamerWerktNiet: "이 방은 사용할 수 없어",
  serverReageertNiet: "서버가 응답하지 않아",
  probeerOpnieuw: "다시 시도해 봐",
  vraagNieuweCode: "코드를 공유한 사람에게 새 코드를 요청해 봐. 방은 몇 시간 뒤에 만료돼.",
  welkeTaalSprekJij: "어떤 언어로 말해?",
  jouwStem: "번역에 사용될 내 목소리",
  man: "남성",
  vrouw: "여성",
  pincode: "핀코드",
  pincodeUitleg: "코드를 공유해 준 사람에게서 받을 수 있어.",
  gaDeKamerIn: "방 입장하기",
  kiesEerstJeTaal: "먼저 언어를 선택해 줘",
  microfoonAanvragen: "마이크 요청 중…",
  toestemmingUitleg: "잠시 후 브라우저가 마이크 권한을 요청할 거야. 허용하지 않으면 텍스트 입력만 가능해.",
  microfoonTestLink: "먼저 마이크를 테스트해 봐",
  stemGaatMee: "이 방에서는 번역뿐만 아니라 내 목소리도 상대방에게 들려.",
  alleenChatMelding: "이 대화는 채팅만 가능해. 메시지를 입력하고 번역을 읽어. 아무것도 소리 내어 읽지 않아.",
  verlooptOm: "만료 시간:",
  nooitVasteKamer: "만료 없음, 고정 방",
  kamer: "방",
  tolkgesprek: "통역 대화",
  juisteKamer: "올바른 방에 들어왔어. 곧 대화에 참여할 수 있어.",
  jij: "나",
  deAnder: "상대방",
  verbinden: "연결 중…",
  verbonden: "연결됨",
  verbindingKwijt: "연결 끊김. 다시 시도 중…",
  wachtenOpAnder: "입장했어. 상대방이 QR 코드를 스캔할 때까지 기다려 줘.",
  allebeiInDeKamer: "둘 다 방에 들어왔어.",
  anderIsWeg: "상대방이 나갔어",
  anderSpreekt: "상대방이 말하는 중…",
  jeKuntErNietIn: "입장할 수 없어",
  overgenomenTitel: "다른 기기에서 대화 이어하기",
  overgenomenUitleg: "이 대화가 방금 다른 기기에서 열렸어. 그 기기에서 대화를 이어가줘.",
  terug: "이전으로",
  geluidStaatUit: "소리가 꺼져 있어. 화면아무 데나 탭해 봐.",
  tikHier: "여기를 탭해",
  bewaardTot: '{tijd}까지 보관됩니다',
  bewaardVast: "고정 방이야. 메시지는 30일 동안 보관돼.",
  spreekIn: "말하기",
  luisteren: "듣는 중… 탭하여 중지",
  uitschrijven: "텍스트 변환 중…",
  tijdOmTeVerbeteren: "직접 수정할 시간",
  altijdZelfVersturen: "항상 직접 확인하고 보내기",
  jijVerstuurtZelf: "내가 직접 보내기",
  uit: "꺼짐",
  sec: "초",
  vertalingMeteenAfspelen: "번역 바로 재생",
  typHierJeBericht: "여기에 메시지 입력…",
  stuur: "전송",
  geenOpnameMogelijk: "이 브라우저에서는 음성 녹음이 지원되지 않아. 텍스트 입력은 가능해.",
  verstaanAls: "인식된 내용:",
  tellerStaatStil: "타이머 정지됨",
  versturen: "보내기",
  wis: "지우기",
  jijZei: "내가 한 말",
  vertaald: "번역됨",
  duimOmhoog: "맞아",
  duimOmlaag: "틀렸어",
  opnieuwProberenKnop: "더 나은 모델로 다시 시도",
  opnieuwProberenBezig: "다시 번역 중…",
  duimTranscriptWoordenlijstUitnodiging: "잘못 인식되었어? 단어장에 바로 등록해 봐:",
  instellingenAanpassen: "설정 변경",
  geldtVoorJullieBeiden: "둘 다에게 적용",
  alleenVoorJou: "나에게만 적용",
  stuurMijnStemMee: "내 진짜 목소리도 함께 전송",
  verbeterSpelfouten: "내 텍스트의 맞춤법 교정",
  verbeterSpelfoutenUit: "설정을 끄면 오타를 포함해서 실제로 인식된 그대로 표시돼.",
  alleenChat: "채팅만: 음성 없음, 마이크 없음",
  alleenChatUitleg: "둘 다 입력해. 번역과 원문이 표시되고, 아무것도 소리 내어 읽지 않아.",
  aangepastDoorDeAnder: "상대방이 설정을 변경했어.",
  foutSpraak: "번역은 완료되었으나, 음성이 나오지 않았어.",
  foutSpraakQuota: "오늘 제공되는 음성 사용량을 모두 소모했어. 텍스트는 정상 작동하며, 음성은 내일부터 다시 지원돼.",
  foutBudgetKamer: "이 대화가 한도에 도달해서 번역이 잠시 멈췄어. 대화를 만든 사람이 한도를 올리면 바로 다시 작동해.",
  foutBudgetMaand: "앱의 이번 달 예산을 모두 썼어. 관리자가 조정하면 번역이 다시 작동해.",
  foutTaal: "지원하지 않는 언어야: 둘 다 같은 언어를 말할 수는 없어.",
  origineel: "원본",
  vertalen: "번역 중…",
  vertalenMislukt: "번역에 실패했어.",
  opnieuwAfspelen: "번역 다시 재생",
  hoorDeAnder: "상대방이 원래 말한 목소리 듣기",
  woordenlijst: "대체 단어장",
  woordenlijstUitleg: "앱이 이름이나 전문 용어를 계속 잘못 인식해? 여기에 올바른 뜻을 등록해 둬.",
  hijHoort: "인식된 단어…",
  jijBedoelt: "실제 의미…",
  ookVolgendeGesprekken: "다음 대화에도 적용 — 체크하지 않으면 이번에만 적용돼",
  voegToe: "추가하기",
  bezig: "처리 중…",
  lijstNietGeladen: "목록을 불러올 수 없어.",
  toevoegenMislukt: "추가하지 못했어.",
  verwijderenMislukt: "삭제하지 못했어.",
  overal: "모든 대화",
  verwijder: "삭제",
  overDitGesprek: "이 대화에 대하여",
  toon: "번역 말투",
  sfeer: "대화 분위기",
  jouwPlek: "내 위치",
  hoeHetWerkt: "서버가 네 녹음을 받아서 한 번에 텍스트로 바꾸고 번역해 줘. 네 진짜 목소리도 상대방에게 전송돼.",
  kleinereTekst: "텍스트 작게",
  grotereTekst: "텍스트 크게",
  insprekenVerbergen: "말하기 버튼 숨기기",
  insprekenTonen: "말하기 버튼 표시",
  toetsenbordVerbergen: "키보드 숨기기",
  toetsenbordTonen: "키보드 표시",
  vormAutomatisch: "자동",
  vormInformeel: "반말",
  vormFormeel: "존댓말",
  sfeerNeutraal: "보통",
  sfeerZakelijk: "비즈니스",
  sfeerOfficieel: "공식적",
  sfeerVriendschappelijk: "친근함",
  sfeerPartner: "연인/파트너",
  foutKamerVol: "이 방은 가득 찼어. 최대 두 명만 입장할 수 있어.",
  plekBezetTitel: "네 자리가 이미 사용 중이야",
  plekBezetUitleg: "이 대화에서 네 쪽 자리에 이미 누군가가 네 언어로 들어와 있어. 대개는 너 자신이야. 다른 기기나 다른 탭에서 대화가 아직 열려 있는 거지. 거기서 닫고 다시 시도해 줘. 자리가 비기까지 1분 30초쯤 걸릴 때도 있어.",
  plekBezetWissel: "너 자신이야? WISSEL을 입력하면 대화를 이 기기로 가져올 수 있어. 그러면 다른 기기는 닫혀.",
  plekBezetKnop: "이 기기로 가져오기",
  foutKamerVerlopen: "이 방은 만료되었거나 닫혔어.",
  foutKamerOnbekend: "존재하지 않는 방이야.",
  foutPinNodig: "이 방에 들어가려면 핀코드가 필요해.",
  foutPinFout: "핀코드가 올바르지 않아.",
  foutProtocol: "앱과 서버가 서로 통신하지 못하고 있어. 페이지를 새로고침해 봐.",
  foutMicroGeweigerd: "마이크 사용을 거부했어. 주소창의 자물쇠 아이콘을 클릭해서 권한을 허용해 줘.",
  foutGeenMicro: "마이크를 찾을 수 없어. 마이크를 연결하고 다시 시도해 봐.",
  foutMicroInGebruik: "다른 프로그램에서 마이크를 사용하고 있어. 해당 프로그램을 닫고 다시 시도해 봐.",
  foutGeenHttps: "마이크는 보안 연결 상태에서만 작동해. https로 이 페이지를 열어 줘.",
  foutMicroOnbekend: "마이크를 시작할 수 없어.",
  foutNietsOpgenomen: "녹음된 내용이 없어. 마이크가 켜져 있는지 확인해 봐.",
  foutNietsGehoord: "아무 소리도 들리지 않았어. 마이크가 켜져 있고 충분히 큰 소리로 말했는지 확인해 봐.",
  foutOpnameTeLang: "녹음이 너무 길어. 조금 더 짧게 끊어서 말해 줘.",
  foutMicroGedempt: "마이크가 음소거되어 있어. 소리를 켜고 다시 시도해 봐.",

  // --- microfoontest ---
  micTitel: "마이크 테스트",
  micOnderschrift: "네 가지 테스트를 연달아, 각각 5초씩. 그동안 계속 말해 줘.",
  micStart: "테스트 시작",
  micTest1: "1. 인식만",
  micTest2: "2. 녹음만",
  micTest3: "3. 동시 — 녹음 먼저",
  micTest4: "4. 동시 — 인식 먼저",
  micFase1: "4개 중 1: 인식만 — 짧은 문장을 말해 봐",
  micFase2: "4개 중 2: 녹음만 — 계속 말해",
  micFase3: "4개 중 3: 녹음 먼저, 그다음 인식 — 계속 말해",
  micFase4: "4개 중 4: 인식 먼저, 그다음 녹음 — 계속 말해",
  micKlaar: "완료",
  micGehoord: "들린 내용",
  micOpnameformaat: "녹음 형식",
  micGeen: "없음",
  micBeveiligd: "보안 연결",
  micJa: "예",
  micNee: "아니오",
  micBrowser: "브라우저",
  micGeenHttps: "https가 아니면 브라우저가 마이크를 열어 주지 않아. localhost에서는 괜찮아.",
  micGeenHerkenning: "이 브라우저에는 음성 인식이 없어.",
  micZegIets: "뭐라도 말해 봐…",
  micWoordenBinnen: "단어가 들어오고 있어",
  micKonNietStarten: "시작할 수 없었어",
  micGeenRecorder: "이 브라우저는 MediaRecorder를 몰라.",
  micOpnemen: "녹음 중…",
  micNietsOpgenomen: "아무것도 녹음되지 않았어",
  micGeenMicrofoon: "마이크 없음",
  micOpnameEerst: "녹음 먼저…",
  micHerkenningEerst: "인식 먼저…",
  micOpnameStarttNiet: "녹음이 시작되지 않았어",
  micSamenGelukt: "동시 성공. 녹음 {kb} kB.",
  micAlleenOpname: "녹음은 됐지만 인식은 안 됐어.",
  micAlleenHerkenning: "인식은 됐지만 녹음은 안 됐어.",
  micGeenVanBeide: "둘 다 안 됐어.",
  micNetwerkFout: "음성 인식이 서버에 연결하지 못했어.",
  micAfgebroken: "녹음이 중단됐어.",
  verslagTitel: "대화 기록",
  verslagWie: "화자",
  verslagOrigineel: "원문",
  verslagVertaling: "번역",
  verslagSpreker: "화자 {x}",
  verslagBerichten: "메시지",
  verslagGemaaktOp: "작성 일시",
  verslagGeenOpname: "말한 그대로의 녹음이 아닙니다.",
  verslagNootOrigineel: "“원문”은 앱이 화자의 말을 이해한 대로의 텍스트입니다.",
  verslagNootCorrectie: "맞춤법 교정이 켜져 있었습니다: 작은 입력 오류가 수정되었습니다.",
  verslagNootAangepast: "말한 사람은 보내기 전에 텍스트를 수정할 수 있었습니다.",
  verslagGesproken: "음성",
  verslagGetypt: "입력",
  verslagMislukt: "번역에 실패했습니다. 상대방은 이 문장을 자신의 언어로 보지 못했습니다.",
  verslagNietKlaar: "이 기록을 만들 때 번역이 아직 완료되지 않았습니다.",
  verslagVertrouwelijk: "기밀.",
  verslagAlleenDeelnemers: "이 기록에는 사적인 대화 내용이 담겨 있으며 참가자만을 위한 것입니다.",
  verslagGewist: "대화 삭제 일시: {tijd}. 그 이후에는 이 기록을 다시 만들 수 없습니다.",
  verslagGewistVast: "고정 방: 각 메시지는 보낸 지 30일 후에 삭제됩니다. 그보다 오래된 메시지는 이 기록에 없습니다.",
};
